import { render, staticRenderFns } from "./CommunityListDrawer.vue?vue&type=template&id=148a8215&"
import script from "./CommunityListDrawer.vue?vue&type=script&lang=js&"
export * from "./CommunityListDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports